/*
  Accessibility
*/
document.querySelectorAll('[data-nav-open], [data-nav-secondary-trigger="cart"]').forEach((el) => {

    const detailKey = el.hasAttribute('data-nav-secondary-trigger') ? 'menu' : el.getAttribute('data-nav-open')
    const detailEl = document.querySelector(`[data-nav-detail="${detailKey}"]`)
    el.addEventListener('click', (event) => {
        event.preventDefault()
        if (el.hasAttribute('data-nav-secondary-trigger')) {
            const ogMenuOpen = document.querySelector(`[data-nav-open="${detailKey}"]`)
            ogMenuOpen.classList.remove('active');
            ogMenuOpen.setAttribute('aria-expanded', 'false')
            detailEl.setAttribute('aria-hidden', 'true')
            return
        }

        if (detailEl.getAttribute('aria-hidden') === 'false') {
            event.currentTarget.setAttribute('aria-expanded', 'false');
            detailEl.setAttribute('aria-hidden', 'true')
            removeTrapFocus(el)
            el.classList.remove('active');
            document.body.removeAttribute('style');
        } else {
            el.classList.add('active');
            document.body.style.overflow = 'hidden';
            event.currentTarget.setAttribute('aria-expanded', 'true');
            detailEl.setAttribute('aria-hidden', 'false')
            trapFocus(detailEl)
        }
    });

    detailEl.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function getFocusableElements(container) {
    const devicePixelRatio = window.devicePixelRatio ?? 2
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    ).filter((el) => {
        const targetSize = (
            el.getBoundingClientRect().width * devicePixelRatio
        ).toFixed(0)
        return !(targetSize === '0' || targetSize === '');
    });
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocusConcrete = undefined) {
    let elements = getFocusableElements(container);
    let first = elements[0];
    let last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) {
            return;
        }
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function (event) {
        if (container.contains(event.target)) {
            return
        }
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    const elementToFocus = elementToFocusConcrete ?? first

    elementToFocus.focus();

    if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
    ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }

    // hate this but works fine - ensures focus in cart
    window.setTimeout(() => {
        elementToFocus.focus();
    }, 100)
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const cart = document.querySelector("site-cart");
    const cartDetail = document.querySelector('#cartDetail')
    let opener = undefined
    if (cart && cartDetail.getAttribute('aria-hidden') === 'false') {
        cart.toggleCart();
        opener = document.querySelector(`[data-nav-open="cart"]`)
    } else {
        const openDetailsElement = event.target.closest('[data-nav-detail][aria-hidden="false"]');
        if (!openDetailsElement) return;
        const detailKey = openDetailsElement.getAttribute('data-nav-detail')
        opener = document.querySelector(`[data-nav-open="${detailKey}"]`)
        openDetailsElement.setAttribute('aria-hidden', 'true')
    }

    opener.setAttribute('aria-expanded', 'false');
    opener.focus();
    opener.classList.remove('active')
}

/*
Site Video
*/

class SiteVideo extends HTMLElement {
    constructor() {
        super();
        this.video = null;
    }

    connectedCallback() {
        this.video = this.querySelector("video");
        this.observe();
    }

    observe() {
        if ("IntersectionObserver" in window) {
            const videoObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(function (video) {
                    const $video = video.target;
                    if (video.isIntersecting) {
                        if ($video.readyState === 4) {
                            $video.play();
                        } else {
                            [].slice
                                .call($video.querySelectorAll("source"))
                                .forEach((source) => {
                                    source.src = source.dataset.src;
                                });
                            $video.load();
                        }
                    } else {
                        if (!$video.paused) {
                            $video.pause();
                        }
                    }
                });
            });

            videoObserver.observe(this.video);
        }
    }

    play() {
        this.video.play();
    }

    pause() {
        this.video.pause();
    }
}

customElements.define("site-video", SiteVideo);

/*
Site Image
*/

class SiteImage extends HTMLElement {
    constructor() {
        super();
        this.observe();
    }

    observe() {
        if ("IntersectionObserver" in window) {
            const imageObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(function (image) {
                    const $image = image.target;
                    if (image.isIntersecting) {
                        $image.classList.add("active");
                        imageObserver.unobserve($image);
                    }
                });
            });
            
            this.querySelector(".mediabox") && imageObserver.observe(this.querySelector(".mediabox"));
        }
    }
}

customElements.define("site-image", SiteImage);

/*
Carousel Prev
*/

class CarouselPrev extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.querySelector("button")) {
            console.warn("You need to have a child button to go to previous!");
        }

        this.addEventListener("click", (e) => {
            const carousel = e.target.closest("site-carousel");

            if (carousel) {
                carousel.previous();
            } else {
                console.error("<carousel-prev> needs to be a child of <site-carousel>");
            }
        });
    }
}

customElements.define("carousel-prev", CarouselPrev);

/*
Carousel Next
*/

class CarouselNext extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.querySelector("button")) {
            console.warn("You need to have a child button to go to next!");
        }

        this.addEventListener("click", (e) => {
            const carousel = e.target.closest("site-carousel");

            if (carousel) {
                carousel.next();
            } else {
                console.error("<carousel-next> needs to be a child of <site-carousel>");
            }
        });
    }
}

customElements.define("carousel-next", CarouselNext);

/*
Carousel Pager
*/

class CarouselPager extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const pagerButtons = Array.from(this.querySelectorAll("button"));

        if (!pagerButtons.length > 1) {
            console.warn("No need for a pager with only one item!");
        }

        pagerButtons.forEach((pager, i) => {
            pager.addEventListener("click", (e) => {
                const carousel = e.target.closest("site-carousel");

                if (carousel) {
                    carousel.slideTo(i);
                } else {
                    console.error(
                        "<carousel-pager> needs to be a child of <site-carousel>"
                    );
                }
            });
        });
    }
}

customElements.define("carousel-pager", CarouselPager);

/*
 * Site Carousel
 */

class SiteCarousel extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        // Wait for DOM to be ready
        requestAnimationFrame(() => {
            this.initializeSwiper();
        });
    }

    initializeSwiper() {
        try {
            const userConfig = this.dataset.config
                ? JSON.parse(this.dataset.config)
                : { slidesPerView: 3, spaceBetween: 20 };

            const prevBtn = this.querySelector('carousel-prev button');
            const nextBtn = this.querySelector('carousel-next button');
            const pagEl = this.querySelector('.swiper-pagination');

            const swiperConfig = {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                ...userConfig
            };

            if (userConfig.navigation === false || !prevBtn || !nextBtn) {
                swiperConfig.navigation = false;
            } else {
                swiperConfig.navigation = {
                    nextEl: nextBtn,
                    prevEl: prevBtn
                };
            }

            if (userConfig.pagination === false || !pagEl) {
                swiperConfig.pagination = false;
            } else {
                swiperConfig.pagination = {
                    el: pagEl,
                    clickable: true,
                    ...(typeof userConfig.pagination === 'object' &&
                    userConfig.pagination !== null
                        ? userConfig.pagination
                        : {})
                };
            }

            this.swiper = new Swiper(this.querySelector('.swiper'), swiperConfig);

            this.handleSlideChange();
        } catch (error) {
            console.error('Error initializing Swiper:', error);
        }
    }

    previous() {
        if (this.swiper && typeof this.swiper.slidePrev === 'function') {
            this.swiper.slidePrev();
        }
    }

    next() {
        if (this.swiper && typeof this.swiper.slideNext === 'function') {
            this.swiper.slideNext();
        }
    }

    slideTo(i) {
        if (this.swiper && typeof this.swiper.slideTo === 'function') {
            this.swiper.slideTo(i);
        }
    }

    handleSlideChange() {
        const pagers = Array.from(this.querySelectorAll('carousel-pager'));
        const fractionEl = this.querySelector('.hero-carousel__fraction');
        const slideCount = parseInt(this.dataset.slideCount || '0', 10);

        const sync = () => {
            if (!this.swiper) return;
            pagers.forEach((pager) => {
                const buttons = Array.from(pager.querySelectorAll('button'));
                const idx = this.swiper.realIndex;
                if (buttons[idx]) {
                    buttons.forEach((button) => button.classList.remove('active'));
                    buttons[idx].classList.add('active');
                }
            });
            if (fractionEl && slideCount > 0) {
                fractionEl.textContent = `${this.swiper.realIndex + 1}/${slideCount}`;
            }
        };

        if (this.swiper) {
            this.swiper.on('slideChange', sync);
            sync();
        }
    }

    // Clean up when element is removed
    disconnectedCallback() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
            this.swiper.destroy();
            this.swiper = null;
        }
    }
}

customElements.define("site-carousel", SiteCarousel);

class OkendoStars extends HTMLElement {
    connectedCallback() {
        this.productId = this.dataset.productId;
        this.fetchOkendoReviewData();
    }

    async fetchOkendoReviewData() {
        const okendoUserId = "8e34414f-e086-4a1a-ac86-923843f0aefe";
        const ratingReviewSpan = this.querySelector(`.js-rating-and-review`);
        const ratingFieldset = this.querySelector(`#js-rating-${this.productId}`);

        try {
            const response = await fetch(
                `https://api.okendo.io/v1/stores/${okendoUserId}/products/shopify-${this.productId}/review_aggregate`
            );
            const reviewData = await response.json();

            if (response.ok) {
                let ratingReviewCount = reviewData.reviewAggregate.ratingAndReviewCount;
                let ratingReviewValueTotal =
                    reviewData.reviewAggregate.ratingAndReviewValuesTotal;
                const rating = ratingReviewValueTotal / ratingReviewCount;
                ratingReviewSpan.innerHTML = `${rating.toFixed(
                    1
                )}  Based on ${ratingReviewCount} ${ratingReviewCount == 1 ? "review" : "reviews"
                    }`;

                if (ratingFieldset) {
                    const ratingInput = ratingFieldset.querySelector(
                        `#star${Math.round(rating)}`
                    );
                    ratingInput.checked = true;
                }
            }
        } catch (error) {
            console.error("Error fetching Okendo review data:", error);
        }
    }
}

customElements.define("okendo-stars", OkendoStars);

/*
Newsletter Popup Signup
*/

class NewsletterPopupSignup extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.submitForm(e);
        });
    }

    async submitForm(e) {
        const email = this.querySelector("[type='email']");
        const age = this.querySelector("[name='age']");
        const pref = Array.from(
            this.querySelectorAll("[name='email-preference']")
        ).find((radio) => radio.checked);

        const submit = this.form.querySelector('[type="submit"]');
        const uri = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
        const body = new URLSearchParams({
            email: email.value,
            $fields: "$age, $emailPreference",
            $age: age.value,
            $emailPreference: pref.value,
            g: "WEBLUN",
        });

        submit.innerHTML = "Submitting...";

        const res = await fetch(uri, { method: "POST", body: body });
        const data = await res.json();
        if (data.success) {
            this.form
                .closest("newsletter-popup-signup")
                .querySelector(".hidden")
                .classList.remove("hidden");
            this.form.classList.add("hidden");
        }
    }
}

customElements.define("newsletter-popup-signup", NewsletterPopupSignup);

/*
Newsletter Footer Signup
*/

class NewsletterFooterSignup extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.submitForm(e);
        });
    }

    async submitForm(e) {
        const submit = this.form.querySelector('[type="submit"]');
        const uri = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
        const body = new URLSearchParams({
            email: this.querySelector(".js-email-input").value,
            g: "WEBLUN",
        });

        submit.innerHTML = "Submitting...";

        const res = await fetch(uri, { method: "POST", body: body });
        const data = await res.json();
        if (data.success) {
            this.form
                .closest("newsletter-footer-signup")
                .querySelector(".hidden")
                .classList.remove("hidden");
            this.form.classList.add("hidden");
        }
    }
}

customElements.define("newsletter-footer-signup", NewsletterFooterSignup);

/*
Send Hint
*/

class SendHint extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.submitForm();
        });
    }

    async submitForm() {
        const submit = this.form.querySelector('[type="submit"]');
        const email = this.querySelector("[name='email']");
        const name = this.querySelector("[name='name']");
        const subject = this.querySelector("[name='subject']");
        const message = this.querySelector("[name='message']");
        const uri = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
        const body = new URLSearchParams({
            $fields: "$first_name, Send Hint Subject, Send Hint Message",
            email: email.value,
            $first_name: name.value,
            "Send Hint Subject": subject.value,
            "Send Hint Message": message.value,
            g: "RuJTgb",
        });

        submit.innerHTML = "sending...";

        const res = await fetch(uri, { method: "POST", body: body });
        const data = await res.json();
        if (data.success) {
            this.form
                .closest("send-hint")
                .querySelector(".hidden")
                .classList.remove("hidden");
            this.form.querySelector(".js-title").classList.add("hidden");
            this.form.querySelector(".js-subtitle").classList.add("hidden");
            this.form.querySelector(".js-form-fields").classList.add("hidden");
            this.form.querySelector(".js-disclaimer").classList.add("hidden");
        }
    }
}

customElements.define("send-hint", SendHint);

/*
FAQs
*/

class Faqs extends HTMLElement {
    constructor() {
        super();
        this.renderAnswer();
    }

    renderAnswer() {
        const arrow = this.querySelector("svg");
        const trigger = this.querySelectorAll("button");
        const container = this.querySelector(".accordion-item");
        const content = this.querySelector(".accordion-content");
        const video = content.querySelector('video');

        trigger.forEach(button => {
            button.addEventListener("click", () => {
                if (container.classList.contains("active")) {
                    container.classList.remove("active");
                    content.style.maxHeight = "0";
                    if (video) {
                        video.pause();
                        video.currentTime = 0;
                    }
                } else {
                    container.classList.add("active");
                    content.style.maxHeight = content.scrollHeight + "px";
                    if (video) {
                        video.play();
                    }
                }
            });
        });
    }
}

customElements.define("question-answer", Faqs);

/*
Site Modal
*/

class SiteModal extends HTMLElement {
    constructor() {
        super();
        this.autoOpenTimeout = this.dataset.autoOpenTimeout;
    }

    openModal() {
        this.querySelector(".modal").classList.add("active");

        const video = this.querySelector("site-video");
        if (video) {
            video.play();
        }
    }

    closeModal() {
        this.querySelector(".modal").classList.remove("active");

        if (this.autoOpenTimeout) {
            localStorage.setItem("newsletter", "true");
        }

        const video = this.querySelector("site-video");
        if (video) {
            video.pause();
        }
    }

    connectedCallback() {
        // Find modal triggers inside AND outside
        const internalOpens = this.querySelectorAll(".modal-open");
        const externalOpens = document.querySelectorAll(`[data-target="${this.id}"]`);
        const closes = this.querySelectorAll(".modal-close");
        const triggerClass = this.dataset.trigger;
        const trigger = document.querySelector(triggerClass);

        if (trigger) {
            trigger.addEventListener("click", (e) => {
                this.openModal();
            });
        }

        [...internalOpens, ...externalOpens].forEach((open) => {
            open.addEventListener("click", (e) => {
                this.openModal();
            });
        });
        closes.forEach((close) => {
            close.addEventListener("click", (e) => {
                this.closeModal();
            });
        });

        // Auto open modal logic
        if (this.autoOpenTimeout) {
            setTimeout(() => {
                if (!localStorage.getItem("newsletter")) {
                    this.openModal();
                }
            }, this.autoOpenTimeout);
        }
    }
}

customElements.define("site-modal", SiteModal);

/*
Number Input
*/

class NumberInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        const button = event.target.closest("button");

        if (button) {
            button.name === "increment" ? this.input.stepUp() : this.input.stepDown();

            if (previousValue !== this.input.value) {
                this.input.dispatchEvent(this.changeEvent);
            }
        }
    }
}

customElements.define("number-input", NumberInput);

/*
Select Input
*/

class SelectInput extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const target = this.querySelector(".select-target");
        const targetText = target.innerHTML;

        this.querySelector("select").addEventListener("change", (e) => {
            const options = Array.from(this.querySelectorAll("option"));
            const active = options.find((o) => o.value === e.target.value);

            if (!!e.target.value) {
                target.innerHTML = active.innerHTML;
                target.classList.add("text-vella-velvet");
            } else {
                target.innerHTML = targetText;
                target.classList.remove("text-vella-velvet");
            }
        });
    }
}

customElements.define("select-input", SelectInput);

/*
Cart Toggle
*/

class CartToggle extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (!this.querySelector("button")) {
            console.warn("Cart toggle component should have a button as a child!");
        }

        this.addEventListener("click", (e) => {
            const cart = document.querySelector("site-cart");
            if (cart) {
                cart.toggleCart();
            }
        });
    }
}

customElements.define("cart-toggle", CartToggle);

/*
Cart Add
*/

// Line-item property key for the subscription checkout note Used by CartAdd and ItemPlanSelector.
const CHECKOUT_NOTE_KEY = "♻️";

class CartAdd extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
        this.hiddenVariantInput = this.form.querySelector('input[name="id"]');
        this.hiddenSellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        this.variantButtons = this.form.querySelectorAll('.variant-button');
        this.cards = this.form.querySelectorAll(".product-form__card");
        this.button = this.querySelector('.button-atc');
        this.buttonText = this.button?.querySelector('.button-text');
        this.loader = this.querySelector('.cart-add-loader');
        this.benefitEls = this.querySelectorAll('.product-benefits');
    }

    connectedCallback() {
        this.variantButtons?.forEach((button) => {
            button.addEventListener("click", () => {
                const variantId = button.dataset.variantId;
                const variantData = this.getVariantData();
                const variant = variantData.find(v => String(v.id) === String(variantId));
                if (!variant) return;

                this.variantButtons.forEach(btn => {
                    const btnVariant = variantData.find(v => String(v.id) === btn.dataset.variantId);
                    btn.classList.remove('bg-vella-highlight-2', 'bg-white', 'bg-gray-100');
                    btn.classList.add(btnVariant?.available !== false ? 'bg-white' : 'bg-gray-100');
                });
                button.classList.remove('bg-white', 'bg-gray-100');
                button.classList.add('bg-vella-highlight-2');

                this.updateVariant(variantId);

                const submitBtn = this.form.querySelector('button[type="submit"]');
                if (submitBtn) {
                    submitBtn.disabled = !variant.available;
                    if (variant.available) {
                        submitBtn.classList.remove('button--disabled');
                        submitBtn.classList.add('button', 'button-atc');
                        submitBtn.setAttribute('aria-label', 'Add to Cart');
                        const prefixSpan = submitBtn.querySelector('span > span:first-child');
                        if (prefixSpan) prefixSpan.textContent = 'add to cart \u00a0';
                    } else {
                        submitBtn.classList.add('button--disabled');
                        submitBtn.classList.remove('button', 'button-atc');
                        submitBtn.setAttribute('aria-label', 'Sold Out');
                        const prefixSpan = submitBtn.querySelector('span > span:first-child');
                        if (prefixSpan) prefixSpan.textContent = 'sold out \u00a0';
                    }
                }

                const otpPrice = variant.price / 100;
                this.updateCardPrices(otpPrice);
                this.updateBenefits(variantId);
            });
        });

        // Selling Plan logic
        this.cards?.forEach((card) => {
            const purchaseTypeRadio = card.querySelector('input[name="purchase_type"]');
            const sellingPlanSelect = card.querySelector('.selling_plan_select select');

            const discountTarget = card.dataset.discountTarget;
            const compareAtPrice = card.querySelector('.product-form__card-old_price');
            const discountBadge = card.querySelector('.discount-badge');

            if (purchaseTypeRadio) {
                purchaseTypeRadio.addEventListener("change", (e) => {

                const sellingPlanOptions = this.form.querySelector('.selling-plan-options');
                const sellingPlanHiddenInput = card.querySelector(".selling-plan-id");
                const cardPriceElement = card.querySelector('.product-form__card-price');

                    this.updateBenefits(this.hiddenVariantInput.value);

                    if (e.target.value === "subscription" && sellingPlanOptions) {
                        sellingPlanOptions.classList.remove("hidden");

                        if (sellingPlanSelect) {
                            if (!sellingPlanSelect.value || sellingPlanSelect.value === "") {
                                sellingPlanSelect.selectedIndex = 0;
                            }

                            const selectedOption = sellingPlanSelect.selectedOptions[0];
                            if (selectedOption?.getAttribute('selling-plan-discount')) {
                                const currentPrice = card.dataset.originalPrice || card.dataset.price;
                                let discount = parseFloat(currentPrice) * (parseFloat(selectedOption.getAttribute('selling-plan-discount')) / 100);
                                let newPrice = parseFloat(currentPrice) - discount;
                                if (cardPriceElement) {
                                    cardPriceElement.innerText = `$${newPrice.toFixed(2).replace('.00', '')}`;
                                }
                                if (compareAtPrice) {
                                    compareAtPrice.innerText = `$${parseFloat(currentPrice).toFixed(2).replace('.00', '')}`;
                                    compareAtPrice.classList.remove("hidden");
                                }
                                this.updatePrice(newPrice);
                            }
                            sellingPlanHiddenInput.value = sellingPlanSelect.value;
                        }
                        if (discountTarget === "OTP") {
                            if (compareAtPrice) compareAtPrice.classList.add("hidden");
                            if (discountBadge) discountBadge.classList.add("hidden");
                        }
                    } else {
                        if (sellingPlanOptions) {
                            sellingPlanOptions.classList.add("hidden");
                        }
                        if (sellingPlanHiddenInput) {
                            sellingPlanHiddenInput.value = "";
                        }
                        if (cardPriceElement) {
                            cardPriceElement.innerText = `$${parseFloat(card.dataset.price).toFixed(2).replace('.00', '')}`;
                        }
                        this.updatePrice(card.dataset.price);
                        if (discountTarget === "OTP") {
                            if (compareAtPrice) compareAtPrice.classList.remove("hidden");
                            if (discountBadge) discountBadge.classList.remove("hidden");
                        }
                    }
                    this.hiddenSellingPlanInput.value = sellingPlanHiddenInput?.value || "";
                });
                if (sellingPlanSelect) {
                    sellingPlanSelect.addEventListener("change", (e) => {
                        const selectedOption = e.target.selectedOptions[0];
                        const selectedSellingPlanId = e.target.value || "";
                        const discount = selectedOption?.getAttribute('selling-plan-discount');
                        const cardPriceElement = card.querySelector('.product-form__card-price');

                        if (discount) {
                            const currentPrice = card.dataset.originalPrice || card.dataset.price;
                            let discountAmount = parseFloat(currentPrice) * (parseFloat(discount) / 100);
                            let newPrice = parseFloat(currentPrice) - discountAmount;
                            if (cardPriceElement) {
                                cardPriceElement.innerText = `$${newPrice.toFixed(2).replace('.00', '')}`;
                            }
                            if (compareAtPrice) {
                                compareAtPrice.innerText = `$${parseFloat(currentPrice).toFixed(2).replace('.00', '')}`;
                                compareAtPrice.classList.remove("hidden");
                            }
                            this.updatePrice(newPrice);
                        }

                        const sellingPlanHiddenInput = card.querySelector(".selling-plan-id");
                        if (sellingPlanHiddenInput) {
                            sellingPlanHiddenInput.value = selectedSellingPlanId;
                        }

                        const selectedRadio = this.form.querySelector('input[name="purchase_type"]:checked');
                        if (selectedRadio && selectedRadio.closest(".product-form__card") === card) {
                            this.hiddenSellingPlanInput.value = selectedSellingPlanId;
                        }
                    });
                }
            }
        });

        const checkedPurchase = this.form.querySelector(
        'input[name="purchase_type"]:checked'
        );

        if (checkedPurchase?.value === 'subscription') {
        this.updateBenefits(this.hiddenVariantInput.value);
        }

        const checkedCard = checkedPurchase?.closest('.product-form__card');

        if (checkedPurchase?.value === 'subscription' && checkedCard) {
            const sellingPlanOptions = checkedCard.querySelector('.selling-plan-options');

            if (sellingPlanOptions) {
                sellingPlanOptions.classList.remove('hidden');
            }

            const sellingPlanHiddenInput = checkedCard.querySelector('.selling-plan-id');
            const sellingPlanSelect = checkedCard.querySelector('.selling_plan_select select');

            if (sellingPlanHiddenInput && sellingPlanSelect) {
                sellingPlanHiddenInput.value = sellingPlanSelect.value;
                this.hiddenSellingPlanInput.value = sellingPlanSelect.value;
            }
        }

        this.form.addEventListener("submit", async (e) => {
            e.preventDefault();

            const cart = document.querySelector("site-cart");
            const variantId = this.hiddenVariantInput.value;
            const sellingPlanId = this.hiddenSellingPlanInput.value;
            const quantityInput = this.form.querySelector('input[name="quantity"]');
            const quantity = quantityInput ? quantityInput.value : 1;
            
            this.button.disabled = true;
            if (this.buttonText) {
                this.buttonText.classList.add('hidden');
            }

            if (this.loader) {
                this.loader.classList.replace('hidden', 'flex');
            }

            if (variantId && cart) {
                if (this.form.querySelector('[name="properties[__shopify_send_gift_card_to_recipient]"]')?.checked) {
                    try {
                        await cart.addGiftCardToCart(variantId, quantity, sellingPlanId);
                    } catch (error) {
                        console.error('Error adding gift card to cart:', error);
                    } finally {
                        if (this.loader) {
                            this.loader.classList.replace('flex', 'hidden');
                        }
                        if (this.buttonText) {
                            this.buttonText.classList.remove('hidden');
                        }
                        this.button.disabled = false;
                    }
                } else {
                    // Attach a line-item note when metafiled is present (e.g. "Sustainable product")
                    const subscriptionNote = this.dataset.subscriptionNote?.trim();
                    const properties = sellingPlanId && subscriptionNote
                        ? { [CHECKOUT_NOTE_KEY]: subscriptionNote }
                        : null;
                    try {
                        // Collect only line item properties
                        const lineItemProperties = {};
                        this.form
                            .querySelectorAll('[data-line-property]')
                            .forEach((input) => {
                                if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
                                const match = input.name.match(/^properties\[(.+)\]$/);
                                if (match && input.value !== '') {
                                    lineItemProperties[match[1]] = input.value;
                                }
                            });
                        // Add the subscription checkout note when applicable.
                        if (properties) Object.assign(lineItemProperties, properties);
                        await cart.addVariantToCart(variantId, quantity, sellingPlanId, lineItemProperties);
                    } catch (error) {
                        console.error('Error adding variant to cart:', error);
                    } finally {
                        if (this.loader) {
                            this.loader.classList.replace('flex', 'hidden');
                        }
                        if (this.buttonText) {
                            this.buttonText.classList.remove('hidden');
                        }
                        this.button.disabled = false;
                    }
                }
            }
        });
    }

    updateCardPrices(basePrice) {
        const price = parseFloat(basePrice);
        this.cards.forEach(card => {
            const cardPriceEl = card.querySelector('.product-form__card-price');
            const cardOldPriceEl = card.querySelector('.product-form__card-old_price');
            const cardTypeInput = card.querySelector('input[name="purchase_type"]');

            card.dataset.price = price;
            if (card.dataset.originalPrice !== undefined) {
                card.dataset.originalPrice = price;
            }

            if (cardTypeInput?.value === 'subscription') {
                if (cardOldPriceEl) cardOldPriceEl.innerText = `$${price.toFixed(2).replace('.00', '')}`;
                const selPlanSelect = card.querySelector('.selling_plan_select select');
                const selOption = selPlanSelect?.selectedOptions[0];
                const disc = parseFloat(selOption?.getAttribute('selling-plan-discount') || '0');
                const subPrice = disc ? price - (price * disc / 100) : price;
                if (cardPriceEl) cardPriceEl.innerText = `$${subPrice.toFixed(2).replace('.00', '')}`;
            } else {
                if (cardPriceEl) cardPriceEl.innerText = `$${price.toFixed(2).replace('.00', '')}`;
            }
        });

        const checkedCard = [...this.cards].find(c =>
            c.querySelector('input[name="purchase_type"]:checked')
        );
        if (checkedCard) {
            const cardPriceEl = checkedCard.querySelector('.product-form__card-price');
            const displayedPrice = cardPriceEl?.innerText.replace('$', '').replace('.00', '') || price;
            this.updatePrice(displayedPrice);
        }
    }

    updateBenefits(variantId) {
        const isSubscription = this.form.querySelector('input[name="purchase_type"]:checked')?.value === 'subscription';
        this.benefitEls.forEach(el => {
            const isActive = el.dataset.variantId === String(variantId);
            const show = isActive && isSubscription;
            el.classList.toggle('hidden', !show);
            el.classList.toggle('flex', show);
        });
    }

    updatePrice(price) {
        let priceParsed = parseFloat(price).toFixed(2);
        this.form.querySelector('button[type="submit"] .product-price').innerText = `$${priceParsed.replace('.00', '')}`;
        
        // Also update sticky button price
        const stickyButton = document.querySelector('.sticky-atc-btn');
        if (stickyButton) {
            const stickyPrice = stickyButton.querySelector('.product-price');
            if (stickyPrice) {
                stickyPrice.innerText = `$${priceParsed.replace('.00', '')}`;
            }
        }
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false' || !window.location.pathname.includes('/products/')) return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariant(variantId) {
        this.currentVariant = this.getVariantData().find(v => String(v.id) === String(variantId));
        this.hiddenVariantInput.value = variantId;
        this.updateURL();
        const carousel = document.querySelector('site-carousel');
        if (carousel?.swiper) {
            const idx = carousel.swiper.slides.findIndex(s => s.dataset.variantId === String(variantId));
            if (idx !== -1) carousel.swiper.slideTo(idx);
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]#product-variants-json').textContent);
        return this.variantData;
    }
}

customElements.define("cart-add", CartAdd);

/*
Cart Cross Sell
*/

class CartCrossSell extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.cart = document.querySelector('site-cart');
        this.button = this.querySelector('button[type="submit"]');
        this.buttonText = this.button.querySelector('.button-text');
        this.loader = this.querySelector('.cross-sell-loader');
        this.crossItems = [...this.cart.querySelectorAll('.cross-sell-item')];
    }

    connectedCallback() {
        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            let id = e.target.querySelector('input[name="id"]').value;
            let quantity = 1;
            let index = parseInt(e.target.dataset.index);
            let item = this.crossItems[index];
            
            this.button.disabled = true;
            if (this.buttonText) {
                this.buttonText.classList.add('hidden');
            }
            if (this.loader) {
                this.loader.classList.replace('hidden', 'flex');
            }

            try {
                await this.cart.addCrossSellToCart(item, id, quantity);
            } catch (error) {
                console.error('Error adding to cart:', error);
            } finally {
                if (this.loader) {
                    this.loader.classList.replace('flex', 'hidden');
                }
                if (this.buttonText) {
                    this.buttonText.classList.remove('hidden');
                }
                this.button.disabled = false;
            }
        });
    }
}

customElements.define("cart-cross-sell", CartCrossSell);

/*
Cart Update
*/

class CartUpdate extends HTMLElement {
    constructor() {
        super();
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    connectedCallback() {
        this.addEventListener(
            "change",
            this.debounce(async (e) => {
                const cart = document.querySelector("site-cart");
                const idx = e.target.dataset.index;
                const val = e.target.value;

                if (cart) {
                    await cart.updateQuantity(idx, val);
                }
            }, 300)
        );
        this.querySelector('button[name="remove"]').addEventListener("click", async (e) => {
            e.preventDefault();
            const cart = document.querySelector("site-cart");
            const idx = e.target.dataset.index;

            if (cart) {
                await cart.updateQuantity(idx, 0);
            }
        });
    }
}

customElements.define("cart-update", CartUpdate);

/*
Site Cart
*/

class SiteCart extends HTMLElement {
    constructor() {
        super();
        this.cart = null;
    }

    connectedCallback() {
        this.cart = document.querySelector(".site-cart");
    }

    openCart() {
        if (this.cart) {
            this.cart.classList.add("active");
            document.body.style.overflow = "hidden";
            trapFocus(document.querySelector('[data-nav-detail="cart"]'))
            document.querySelector('[data-nav-detail="cart"]').setAttribute('aria-hidden', 'false')
        }
    }

    closeCart() {
        if (this.cart) {
            this.cart.classList.remove("active");
            document.body.removeAttribute("style");
            removeTrapFocus(document.querySelector('[data-nav-open="cart"]'))
            document.querySelector('[data-nav-detail="cart"]').setAttribute('aria-hidden', 'true')
        }
    }

    toggleCart() {
        if (this.cart.classList.contains("active")) {
            this.closeCart();
        } else {
            this.openCart();
        }
    }

    getCartSections() {
        return [
            {
                section: "main-cart-items",
                selector: "#main-cart-items",
            },
            {
                section: "main-cart-footer",
                selector: "#main-cart-footer",
            },
            {
                section: "main-cart-header",
                selector: "#main-cart-header",
            },
            {
                section: "cart-icon-bubble",
                selector: "#cart-icon-bubble",
            },
            {
                section: "main-cart-nav",
                selector: "#main-cart-nav",
            },
        ];
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    renderCartSections(sections) {
        const getSections = this.getCartSections();
        const sectionsArr = sections ? Object.keys(sections) : [];

        sectionsArr?.forEach((sectionKey) => {
            const activeSection = getSections.find((s) => s.section === sectionKey);
            const elToReplace = document.querySelector(activeSection.selector);
            if (elToReplace) {
                elToReplace.innerHTML = this.getSectionInnerHTML(
                    sections[sectionKey],
                    activeSection.selector
                );
            }
        });

        window.setTimeout(() => {
            trapFocus(document.querySelector('[data-nav-detail="cart"]'))
        }, 100)
    }

    buildConfig(body) {
        return {
            body: body,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: `application/json`,
            },
        };
    }

    addVariantToCart(id, quantity = 1, sellingPlan, properties = null) {
        const item = sellingPlan
            ? { id, quantity, selling_plan: sellingPlan }
            : { id, quantity };
        if (properties && Object.keys(properties).length > 0) {
            item.properties = properties;
        }
        const items = [item];
        const sections = this.getCartSections().map((s) => s.section);
        const body = JSON.stringify({ items, sections });
        const config = this.buildConfig(body);

        this.toggleCart();

        return fetch(`/cart/add`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }

                checkGWP(null, async (newResponse) => {
                    if (newResponse) response = newResponse;

                    this.renderCartSections(response.sections);
                });
            })
            .catch((e) => {
                // handle error
            });
    }

    addGiftCardToCart(id, quantity = 1) {
        const email = document.querySelector('[name="properties[Recipient email]"]').value;
        const name = document.querySelector('[name="properties[Recipient name]"]').value;
        const message = document.querySelector('[name="properties[Message]"]').value;
        const sendon = document.querySelector('[name="properties[Send on]"]').value;
        let properties = {
            "__shopify_offset": '',
            "__shopify_send_gift_card_to_recipient": 'if_present',
        };
        if (email.length > 0) {
            properties['Recipient email'] = email;
        }
        if (name.length > 0) {
            properties['Recipient name'] = name
        }
        if (message.length > 0) {
            properties['Message'] = message
        }
        if (sendon.length > 0) {
            properties['Send on'] = sendon
        }
        const items = [
            {
                id,
                quantity,
                properties: properties
            },
        ];
        const sections = this.getCartSections().map((s) => s.section);
        const body = JSON.stringify({ items, sections });
        const config = this.buildConfig(body);

        this.toggleCart();

        return fetch(`/cart/add`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }

                this.renderCartSections(response.sections);
            })
            .catch((e) => {
                // handle error
            });
    }

    updateQuantity(line, quantity) {
        const items = document.querySelectorAll("#main-cart-items li");
        const sections = this.getCartSections().map((s) => s.section);
        const body = JSON.stringify({ line, quantity, sections });
        const config = this.buildConfig(body);
        const item = items[line - 1];
        const price = item.querySelector(".cart-price");
        const loader = item.querySelector(".cart-loader");

        price.classList.add("hidden");
        loader.classList.remove("hidden");

        if (item.dataset.gwp && quantity === 0) {
            sessionStorage.setItem('gwp', 'removed');
        }

        return fetch("/cart/change", config)
            .then((response) => response.json())
            .then((response) => {
                checkGWP(response, async (newResponse) => {
                    price.classList.remove("hidden");
                    loader.classList.add("hidden");

                    if (newResponse) response = newResponse;

                    this.renderCartSections(response.sections);
                });
            })
            .catch(() => {
                // handle error
            });
    }

    updateSellingPlan(line, quantity, sellingPlan, properties) {
        const items = document.querySelectorAll("#main-cart-items li");
        const sections = this.getCartSections().map((s) => s.section);
        const payload = { line, quantity, selling_plan: sellingPlan, sections };
        // properties === undefined: leave the line's properties untouched.
        // An object overwrites them; a blank-valued note clears it on one-time.
        if (properties !== undefined) payload.properties = properties;
        const body = JSON.stringify(payload);
        const config = this.buildConfig(body);
        const item = items[line - 1];
        const price = item.querySelector(".cart-price");
        const loader = item.querySelector(".cart-loader");

        price.classList.add("hidden");
        loader.classList.remove("hidden");

        return fetch("/cart/change", config)
            .then((response) => response.json())
            .then((response) => {
                checkGWP(response, async (newResponse) => {
                    price.classList.remove("hidden");
                    loader.classList.add("hidden");

                    if (newResponse) response = newResponse;

                    this.renderCartSections(response.sections);
                });
            })
            .catch(() => {
                // handle error
            });
    }

    addCrossSellToCart(item, id, quantity = 1) {
        const sections = this.getCartSections().map((s) => s.section);
        const body = JSON.stringify({ id, quantity, sections });
        const config = this.buildConfig(body);

        return fetch(`/cart/add`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }

                checkGWP(null, async (newResponse) => {
                    if (newResponse) response = newResponse;

                    this.renderCartSections(response.sections);
                    this.openCart()
                });
            })
            .catch((e) => {
                // handle error
            });
    }
}

customElements.define("site-cart", SiteCart);

/*
Site Marquee
*/

class SiteMarquee extends HTMLElement {
    constructor() {
        super();
        const speed = this.dataset.speed || "50";
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = this.getInnerHTML();

        const contentWidth = this.querySelector('[slot="content"]').scrollWidth / 2;
        
        const duration = contentWidth / parseFloat(speed);
        
        shadowRoot.innerHTML = this.getInnerHTML(contentWidth, duration);
    }

    getInnerHTML(width = 0, duration = 20) {
        return `
      <style>
        ::slotted([slot="content"]) {
          display: grid;
          grid-auto-flow: column;
          align-items: center;
          height: 100%;
        }
        .marquee-cont {
          display: flex;
          overflow: hidden;
          width: 100%;
        }
        .marquee-list {
          display: flex;
          white-space: nowrap;
          animation: marquee ${duration}s linear infinite;
          height: 100%;
        }

        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-${width}px);
          }
        }
      </style>
      <div class="marquee-cont">
        <div class="marquee-list">
          <slot name="content"></slot>
          <slot name="content"></slot>
        </div>
      </div>
    `;
    }
}

customElements.define("site-marquee", SiteMarquee);

/*
Consortium Signup
*/

class ConsortiumSignup extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
    }

    connectedCallback() {
        this.form.addEventListener("submit", (e) => {
            e.preventDefault();
            this.handleSubmit();
        });

        const radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        radios.forEach((radio) => {
            const practiceName = this.form.querySelector('[name="practice_name"]');
            const practiceWebsite = this.form.querySelector(
                '[name="practice_website"]'
            );
            const namePh = practiceName.getAttribute("placeholder");
            const websitePh = practiceWebsite.getAttribute("placeholder");

            radio.addEventListener("change", (e) => {
                practiceName.required = e.target.value === "yes" ? true : false;
                practiceWebsite.required = e.target.value === "yes" ? true : false;

                practiceName.setAttribute(
                    "placeholder",
                    e.target.value === "yes" ? `${namePh}*` : namePh
                );
                practiceWebsite.setAttribute(
                    "placeholder",
                    e.target.value === "yes" ? `${websitePh}*` : websitePh
                );
            });
        });
    }

    async handleSubmit() {
        const submit = this.querySelector('[type="submit"]');
        const submitText = submit.innerHTML;
        const formData = new FormData(this.form);
        const formDataObj = {};
        formData.forEach(function (value, key) {
            formDataObj[key] = value;
        });

        submit.innerHTML = "submitting...";

        try {
            const signup = await fetch(
                "https://vella-next.vercel.app/api/vella/consortium-signup",
                {
                    method: "POST",
                    body: JSON.stringify(formDataObj),
                }
            );
            const resp = await signup.json();
            this.querySelector(".hidden").classList.remove("hidden");
            this.form.classList.add("hidden");
        } catch (e) {
            console.log(e.message);
        }

        submit.innerHTML = submitText;
    }
}

customElements.define("consortium-signup", ConsortiumSignup);

/*
Notify Me
*/

class NotifyMe extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector("form");
        this.submit = this.form.querySelector('[type="submit"]');
        this.success = this.querySelector(".success");
        this.companyId = this.getAttribute('data-company-id')
        this.form.addEventListener("submit", this.submitForm.bind(this));
    }

    async submitForm(e) {
        e.preventDefault()
        this.renderLoading()

        const data = {
            email: this.querySelector("[type='email']").value,
            variant: this.form.dataset.variantId,
        }

        const config = {
            method: 'POST',
            headers: {
                accept: 'application/json',
                revision: '2024-02-15',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        channels: ['EMAIL'],
                        profile: {
                            data: { type: 'profile', attributes: { email: data.email } },
                            email: data.email
                        }
                    },
                    relationships: {
                        variant: {
                            data: {
                                type: 'catalog-variant',
                                id: `$shopify:::$default:::${this.form.dataset.variantId}`
                            }
                        }
                    }
                }
            })
        }

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.companyId}`, config)
            .then((response) => response.text())
            .then((response) => {
                if (response?.length) {
                    this.renderError()
                    return
                }
                this.renderSuccess()
            })
            .catch((e) => {
                this.renderError()
                console.error(e)
            })
            .finally(() => {

            })
    }

    renderSuccess() {
        this.form.classList.add("hidden");
        this.success.classList.remove("hidden");
        this.submit.innerHTML = 'Success'
        this.success.innerHTML = 'Success! You’ll receive an email when this product comes back in stock.'
    }

    renderError() {
        this.success.classList.remove("hidden");
        this.success.innerHTML = 'Please double check your email address and try again.'
        this.submit.innerHTML = 'Submit'
    }

    renderLoading() {
        this.submit.innerHTML = "Submitting...";
        this.success.classList.add("hidden");
        this.success.innerHTML = ''
    }
}

customElements.define("notify-me", NotifyMe);

class NotifyMeTrigger extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.modal = document.getElementById('notify-me-modal');
        this.modalEl = this.modal && this.modal.querySelector('.modal');
        this.closeBtns = this.modal && this.modal.querySelector('.modal-close');
        this.closeBtns?.addEventListener('click', this.handleClose.bind(this));
        this.button.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(e) {
        e.preventDefault();
        this.variantId = this.button.getAttribute('data-variant-id');
        this.form = this.modal && this.modal.querySelector('form[data-variant-id]');
        if (this.form) {
            this.form.setAttribute('data-variant-id', this.variantId);
        }
        if (this.modalEl) {
            this.modalEl.classList.remove('opacity-0', 'invisible');
            this.modalEl.classList.add('opacity-100', 'visible');
        }
    }

    handleClose(e) {
        e.preventDefault();
        this.modalEl.classList.add('opacity-0', 'invisible');
        this.modalEl.classList.remove('opacity-100', 'visible');
    }
}

customElements.define("notify-me-trigger", NotifyMeTrigger);
/* DynamicGWP */

class DynamicGWP extends HTMLElement {
    constructor() {
        super()
        this.variantId = this.getAttribute('data-gwp-id')
        this.action = this.getAttribute('data-gwp-action')
        this.removeButton = this.querySelector('button[data-remove-disable]')
        this.removeButton?.addEventListener('click', this.removeAndDisable.bind(this))
    }

    connectedCallback() {
        let updates = {
            [this.variantId]: undefined
        }
        if (this.action === 'ADD') {
            updates[this.variantId] = 1
            void this.update(updates)
        }
        if (this.action === 'REMOVE') {
            updates[this.variantId] = 0
            void this.update(updates)
        }
        if (this.action === 'CORRECT') {
            updates[this.variantId] = 1
            void this.update(updates)
        }
    }

    async update(updates, attributes = undefined) {
        const cart = document.querySelector('site-cart')
        const sections = cart.getCartSections().map((s) => s.section);
        const body = attributes ? JSON.stringify({ updates, sections, attributes }) : JSON.stringify({ updates, sections })

        fetch(`/cart/update.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body,
        }).then((response) => response.json()).then(response => {
            cart.renderCartSections(response.sections);
        })
    }

    async removeAndDisable() {
        const attributes = {
            '_gwp_decline': 'true'
        }
        const updates = {
            [this.variantId]: 0
        }
        void this.update(updates, attributes)
    }
}

customElements.define('dynamic-gwp', DynamicGWP)

class ItemPlanSelector extends HTMLElement {
    constructor() {
        super();
        this.select = this.querySelector("select");
        this.trigger = this.querySelector(".trigger-plan-selector");
        const cart = document.querySelector("site-cart");

        this.trigger?.addEventListener('click', async (e) => {
            e.preventDefault();
            this.select.classList.remove("hidden");
            this.trigger.classList.add("hidden");
            const line = parseInt(this.dataset.line);
            const quantity = parseInt(this.dataset.quantity);
            const val = e.target.dataset.firstSellingPlanId;
            await cart.updateSellingPlan(line, quantity, val, this.noteProperties(val));
        });
        this.select?.addEventListener("change", async (e) => {
            const line = parseInt(this.dataset.line);
            const quantity = parseInt(this.dataset.quantity);
            const val = e.target.value;

            if (cart) {
                await cart.updateSellingPlan(line, quantity, val, this.noteProperties(val));
                if (val === "") {
                    this.select.classList.add("hidden");
                    this.trigger.classList.remove("hidden");
                }
            }
        });
    }

    // Keep the checkout note in sync with the line's plan state: set it when a
    // plan is selected, clear it (blank value) on one-time. Returns undefined for
    // products without the note so their properties are left alone.
    noteProperties(sellingPlan) {
        const note = this.dataset.subscriptionNote?.trim();
        if (!note) return undefined;
        // Blank value forces Shopify to drop the property (empty {} doesn't clear reliably).
        return sellingPlan ? { [CHECKOUT_NOTE_KEY]: note } : { [CHECKOUT_NOTE_KEY]: "" };
    }
}

customElements.define('item-plan-selector', ItemPlanSelector)

class HotspotInfo extends HTMLElement {
    constructor() {
        super();
        this.dot = this.querySelector('.hotspot-dot');
        this.popup = this.querySelector('.hotspot-popup');
        this.close = this.querySelector('.close-popup');
    }

    connectedCallback() {
        this.dot.addEventListener('click', this.togglePopup.bind(this));
        this.close.addEventListener('click', this.iconClosePopup.bind(this));
        document.addEventListener('click', this.popupClickClose.bind(this));
        document.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown.bind(this));
        document.removeEventListener('click', this.popupClickClose.bind(this));
    }

    togglePopup(e) {
        e.stopPropagation();
        if (!this.popup.classList.contains('active')) {
            this.popup.classList.add('active');
            this.popup.style.opacity = '1';
            this.popup.style.pointerEvents = 'auto';
        } else {
            this.closePopup();
        }
        //videos.forEach(video => video.pause());
    }        
    
    iconClosePopup(e) {
        e.stopPropagation();
        this.closePopup();
    }

    handleKeydown(e) {
        if (e.key === 'Escape') {
            this.closePopup();
        }
    }
    
    popupClickClose(e) {
        if (!this.popup.contains(e.target) && !this.dot.contains(e.target)) {
            this.closePopup();
        }
    }

    closePopup() {
        this.popup.classList.remove('active');
        this.popup.style.opacity = '0';
        this.popup.style.pointerEvents = 'none';
    }
}

customElements.define('hotspot-info', HotspotInfo);

class StickyAtcBanner extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    // Get references
    this.stickyBanner = this;
    this.stickyButton = this.querySelector('.sticky-atc-btn');
    this.stickyAtcInfo = this.querySelector('.sticky-atc-info');
    this.stickyAtcText = this.querySelector('.sticky-atc-text');
    
    // Find main button (outside the component)
    this.mainButton = document.querySelector('.product-form .button-atc, .product-form .notify-me, .product-form button[aria-label="Sold Out"]');
    
    if (!this.stickyBanner || !this.mainButton) return;
    
    // Make sticky button click the main ATC button
    if (this.stickyButton && this.mainButton) {
      this.stickyButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.mainButton.click();
      });
    }
    
    // Copy yotpo review span to sticky banner
    if (this.stickyAtcInfo) {
      this.copyYotpoReview();
    }
    
    // Setup intersection observer for visibility toggle
    this.setupVisibilityObserver();
  }

  copyYotpoReview() {
    const attemptCopy = () => {
      const yotpoElement = document.querySelector('.yotpo-sr-bottom-line-summary');
      if (yotpoElement) {
        const yotpoSpan = yotpoElement.querySelector('span');
        if (yotpoSpan) {
          const clonedSpan = yotpoSpan.cloneNode(true);
          // Give it a unique ID so we can target it specifically
          clonedSpan.id = 'sticky-yotpo-review';
          // Remove cursor: pointer style from the cloned element and its first child
          clonedSpan.style.removeProperty('cursor');
          const firstChild = clonedSpan.firstElementChild;
          if (firstChild) {
            firstChild.style.removeProperty('cursor');
          }
          // Remove only the previously cloned yotpo span
          const existingYotpo = this.stickyAtcText.querySelector('#sticky-yotpo-review');
          if (existingYotpo) {
            existingYotpo.remove();
          }
          this.stickyAtcText.appendChild(clonedSpan);
          return true;
        }
      }
      return false;
    };
    
    // Try immediately
    if (!attemptCopy()) {
      // Retry a few times with delays (up to 10 seconds total)
      let attempts = 0;
      const maxAttempts = 20;
      const retryInterval = setInterval(() => {
        if (attemptCopy() || attempts >= maxAttempts) {
          clearInterval(retryInterval);
        }
        attempts++;
      }, 500);
    }
  }

  setupVisibilityObserver() {
    const visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Main button is in view, hide sticky banner
          this.stickyBanner.setAttribute('data-visible', 'false');
        } else {
          // Main button is out of view, show sticky banner
          this.stickyBanner.setAttribute('data-visible', 'true');
        }
      });
    }, {
      threshold: 0
    });
    
    visibilityObserver.observe(this.mainButton);
  }
}

customElements.define('sticky-atc-banner', StickyAtcBanner);



class JoinTheListTrigger extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.formId = this.dataset.formId;
    if (!this.button || !this.formId) return;
    this.button.addEventListener(
      'click',
      this.handleClick.bind(this)
    );
  }

  handleClick(e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push([
      'openForm',
      this.formId
    ]);
  }
}

customElements.define('join-the-list-trigger',JoinTheListTrigger);

